import axios from "axios";
export const FETCH_LEADERBOARD = "FETCH_LEADERBOARD";
export const FETCH_USER = "FETCH_USER";
export const RESTRICT_USER = "RESTRICTED_USER";


const base = "https://prod.vertexprotocol-backend.com";

export function fetchLeaderboard(page) {
  const limit = 10;
  const start = (page - 1) * limit;

  return dispatch => {
    axios.post(`${base}/indexer`, {
      leaderboard: {
        start: start,
        limit: limit
      }
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        dispatch({
          type: FETCH_LEADERBOARD,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: RESTRICT_USER,
          payload: error
        });
      });
  };
}

export function fetchUser(address) {
  const newAddress = address + "64656661756c740000000000" 

  return dispatch => {
    axios.post(`${base}/indexer`, {
      leaderboard: {
        subaccount: newAddress
      }
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        dispatch({
          type: FETCH_USER,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_USER,
          payload: []
        });
      });
  };
}